module.exports = __webpack_public_path__ + "static/media/threshold.4fbe0531.png";